import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import s from "./CreateContent.module.scss";

const CreateContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t("page.analytics.referrer.performance.create.function.dialog.content.1")}
          mandatory
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "company")}
          onfocusFn={() => textInputOnFocus("company")}
          onblurFn={() => textInputOnBlur("company")}
          sxParams={{ textFocus: focus.company }}
        />
      </div>

      <div>
        <OutlinedText
          label={t("page.analytics.referrer.performance.create.function.dialog.content.2")}
          mandatory
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "email")}
          onfocusFn={() => textInputOnFocus("email")}
          onblurFn={() => textInputOnBlur("email")}
          sxParams={{ textFocus: focus.email }}
        />
      </div>
    </div>
  );
};

export default React.memo(CreateContent);
